// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import '../src/api/httpService'
// import wx from 'weixin-jsapi'
import { Picker } from 'vant'
import { Popup } from 'vant'
import { Cell, CellGroup } from 'vant'
import { DatetimePicker } from 'vant'
import { Toast } from 'vant'
import { Tab, Tabs } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant'
import { RadioGroup, Radio } from 'vant'
import { Icon } from 'vant';
import { Calendar } from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'babel-polyfill'
import moment from 'moment'
import VueClipboard from 'vue-clipboard2'
// import Vconsole from 'vconsole'

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.use(VueClipboard)
Vue.use(Picker).use(Popup).use(Icon).use(Cell).use(CellGroup).use(DatetimePicker).use(Toast).use(Checkbox).use(CheckboxGroup).use(RadioGroup).use(Radio).use(ElementUI).use(Tab).use(Tabs).use(Calendar)
console.log(process.env.API_HOST, 'process.env.API_HOST', process.env.ENV_CONFIG)
Vue.config.productionTip = false
Vue.prototype.$http= axios
Vue.prototype.$store = store
Vue.prototype.$moment = moment
moment.locale('zh-cn');//需要汉化


var clwidth=document.body.clientWidth||document.documentElement.clientWidth;
var htmldom=document.getElementsByTagName('html')[0];
htmldom.style.fontSize=Math.ceil(clwidth*0.13)+'px';
// let vConsole = new Vconsole();
// export default vConsole
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js